import { SecretsStore } from "./SecretsStore";

export class WebSecretsStore extends SecretsStore {
  set(key: string, value: string) {
    window.localStorage.setItem(key, value);
  }

  get(key: string): string {
    return window.localStorage.getItem(key);
  }

  remove(key: string) {
    window.localStorage.removeItem(key);
  }

}
